import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import SelectUI from '../../../widgets/input/SelectUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import './Triangulation6Months.css'

const Triangulation6MonthsUI = ({
    context, account,
    accountMonthGstList, accountMonthBankList, nMonthGstTotal, nMonthBankTotal, lastNMonths, lastNMonthsList, onLastNMonthsChange,
    showDetails, showGstData, onShowGstDataClick
}) => {
    // Get the end month/year from the last item in the list
    const getEndMonthYear = () => {
        const list = showGstData ? accountMonthGstList : accountMonthBankList;
        if (list && list.length > 0) {
            return list[list.length - 1].yearMonth; // e.g., "Nov-25"
        }
        return '';
    };
    const endMonthYear = getEndMonthYear();

    return <CardUI className='g_m_top_100 g_m_bottom_200 c_tr6m'
        title={
            <div className='g_flex_h'>
                <span>Cash Generation</span>
                <span className='g_flex_h'>
                    <span className='g_flex_h'>
                        <span className='g_muted g_small g_m_right_50'>
                            Show GST data
                        </span>
                        <SwitchUI checked={showGstData} onChange={onShowGstDataClick} />
                    </span>
                    <span className='g_m_left_100'><SelectUI selectedKey={lastNMonths} optionList={lastNMonthsList} onChange={onLastNMonthsChange} placeholder='' /></span>
                </span>
            </div>
        }>
        <table>
            <thead className='g_sticky'>
                <tr>
                    <th className='g_text_center'><b>Month</b></th>
                    <th className='g_text_center' colSpan='3'><b>As per GST data</b></th>
                    <th className='g_text_center' colSpan='3'><b>As per Bank data</b></th>
                </tr>
                <tr>
                    <th></th>
                    <th>Revenue</th>
                    <th>Expenses</th>
                    <th>Profit/(Loss)</th>
                    <th>Revenue</th>
                    <th>Expenses</th>
                    <th>Profit/(Loss)</th>
                </tr>
            </thead>
            <tbody>
                {
                    showGstData && nMonthGstTotal && accountMonthGstList.map((accountMonth, i) =>
                        <RowUI key={i} context={context} account={account} accountMonth={accountMonth}
                        />
                    )
                }
                {
                    showGstData && nMonthGstTotal &&
                    <TotalRowUI total={nMonthGstTotal} />
                }
                {
                    showGstData && nMonthGstTotal &&
                    <AdjustmentRowUI total={nMonthGstTotal} lastNMonths={lastNMonths} showDetails={showDetails} showGstData={showGstData} endMonthYear={endMonthYear} />
                }
                {
                    !showGstData && nMonthBankTotal && accountMonthBankList.map((accountMonth, i) =>
                        <RowUI key={i} context={context} account={account} accountMonth={accountMonth}
                        />
                    )
                }
                {
                    !showGstData && nMonthBankTotal &&
                    <TotalRowUI total={nMonthBankTotal} />
                }
                {
                    !showGstData && nMonthBankTotal &&
                    <AdjustmentRowUI total={nMonthBankTotal} lastNMonths={lastNMonths} showDetails={showDetails} showGstData={showGstData} endMonthYear={endMonthYear} />
                }
            </tbody>
        </table>
    </CardUI>
}

const AdjustmentRowUI = ({ total, lastNMonths, showDetails, showGstData, endMonthYear }) =>
    <>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Less: Salary cost</td>
            <td className='g_text_right'>{total.totalBankSalaryF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Less: EMI</td>
            <td className='g_text_right'>{total.totalBankEmiF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Less: Finance cost</td>
            <td className='g_text_right'>{total.totalBankFinanceCostF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Less: Bank charges</td>
            <td className='g_text_right'>{total.totalBankChargesF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Less: Other expenses</td>
            <td className='g_text_right'>{total.totalBankOtherExpenseF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}><b>Cash generation</b></td>
            <td className='g_text_right'><b>
                {
                    showGstData ?
                        total.totalGstNetProfitLoss < 0 ?
                            `(${total.totalGstNetProfitLossF4})` : total.totalGstNetProfitLossF4

                        :
                        total.totalBankNetProfitLoss < 0 ?
                            `(${total.totalBankNetProfitLossF4})` : total.totalBankNetProfitLossF4
                }
            </b></td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>Add: Capital expenditure</td>
            <td className='g_text_right'>{total.capitalExpenditureF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Add: Provisional inventory<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.provisionalInventoryFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {
                    total.provisionalInventory < 0 ?
                        `(${total.provisionalInventoryF4})` : total.provisionalInventoryF4
                }
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Add: Receivables<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.currentReceivablesFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>{total.currentReceivablesF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Add: Advances Paid<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.advancesPaidFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>{total.advancesPaidF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Add: Provisional Investments<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.provisionalEndingCashInvestmentFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {
                    total.provisionalEndingCashInvestment < 0 ?
                        `(${total.provisionalEndingCashInvestmentF4})` : total.provisionalEndingCashInvestmentF4
                }
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Less: Payables<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.currentPayablesFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>{total.currentPayablesF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Less: Advances Received <br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.advancesReceivedFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'>{total.advancesReceivedF4}</td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}><b>Profit/(Loss)</b><br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>{total.netCashGenerationFormula}</span>
                }
            </td>
            <td className='g_text_right g_text_top'><b>
                {
                    total.netCashGeneration < 0 ?
                        `(${total.netCashGenerationF4})` : total.netCashGenerationF4
                }
            </b></td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}><b>Margin Summary</b></td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Gross Margin<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.grossGstProfitLossFormula : total.grossBankProfitLossFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {
                    showGstData ?
                        (total.grossGstProfitLoss < 0 ?
                            `(${total.grossGstProfitLossF4})` : total.grossGstProfitLossF4)
                        :
                        (total.grossBankProfitLoss < 0 ?
                            `(${total.grossBankProfitLossF4})` : total.grossBankProfitLossF4)
                }
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Gross Margin %<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.grossGstProfitLossPFormula : total.grossBankProfitLossPFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {showGstData ? total.grossGstProfitLossP : total.grossBankProfitLossP}%
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Net Margin<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.netGstProfitLossFormula : total.netBankProfitLossFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {
                    showGstData ?
                        (total.netGstProfitLoss < 0 ?
                            `(${total.netGstProfitLossF4})` : total.netGstProfitLossF4)
                        :
                        (total.netBankProfitLoss < 0 ?
                            `(${total.netBankProfitLossF4})` : total.netBankProfitLossF4)
                }
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Net Margin %<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.netGstProfitLossPFormula : total.netBankProfitLossPFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {showGstData ? total.netGstProfitLossP : total.netBankProfitLossP}%
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Cash Margin<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.cashGstMarginFormula : total.cashBankMarginFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {
                    showGstData ?
                        (total.cashGstMargin < 0 ?
                            `(${total.cashGstMarginF4})` : total.cashGstMarginF4)
                        :
                        (total.cashBankMargin < 0 ?
                            `(${total.cashBankMarginF4})` : total.cashBankMarginF4)
                }
            </td>
        </tr>
        <tr>
            <td colSpan={showGstData ? '3' : '6'}>
                Cash Margin %<br />
                {
                    showDetails &&
                    <span className='g_muted g_small frm'>
                        {showGstData ? total.cashGstMarginPFormula : total.cashBankMarginPFormula}
                    </span>
                }
            </td>
            <td className='g_text_right g_text_top'>
                {showGstData ? total.cashGstMarginP : total.cashBankMarginP}%
            </td>
        </tr>
        {/* Conditional display based on Cash Margin */}
        {
            (showGstData ? total.cashGstMargin : total.cashBankMargin) < 0 ?
                // Negative Cash Margin: Show Sources of Funds (hide CC Lines)
                <>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}><b>Sources of Funds</b></td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>Loans taken (CIBIL loans)</td>
                        <td className='g_text_right g_text_top'>{total.cibilLoansF4}</td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            Promoter Contribution<br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.promoterContributionFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'>
                            {
                                total.promoterContribution < 0 ?
                                    `(${total.promoterContributionF4})` : total.promoterContributionF4
                            }
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            Audited Ending Cash (Opening Cash)<br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.auditedEndingCashFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'>
                            {
                                total.auditedEndingCash < 0 ?
                                    `(${total.auditedEndingCashF4})` : total.auditedEndingCashF4
                            }
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            Audited Ending Cash Investment
                        </td>
                        <td className='g_text_right g_text_top'>
                            {
                                total.auditedEndingCashInvestment < 0 ?
                                    `(${total.auditedEndingCashInvestmentF4})` : total.auditedEndingCashInvestmentF4
                            }
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            <b>Audited Cash</b><br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.auditedCashFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'><b>
                            {
                                total.auditedCash < 0 ?
                                    `(${total.auditedCashF4})` : total.auditedCashF4
                            }
                        </b></td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            Provisional Ending Cash<br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.provisionalEndingCashFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'>
                            {
                                total.provisionalEndingCash < 0 ?
                                    `(${total.provisionalEndingCashF4})` : total.provisionalEndingCashF4
                            }
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            Provisional Ending Cash Investment<br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.provisionalEndingCashInvestmentFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'>
                            {
                                total.provisionalEndingCashInvestment < 0 ?
                                    `(${total.provisionalEndingCashInvestmentF4})` : total.provisionalEndingCashInvestmentF4
                            }
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={showGstData ? '3' : '6'}>
                            <b>Current Cash as on {endMonthYear}</b><br />
                            {
                                showDetails &&
                                <span className='g_muted g_small frm'>{total.provisionalCashFormula}</span>
                            }
                        </td>
                        <td className='g_text_right g_text_top'><b>
                            {
                                total.provisionalCash < 0 ?
                                    `(${total.provisionalCashF4})` : total.provisionalCashF4
                            }
                        </b></td>
                    </tr>
                    {
                        total.currentYear !== "" &&
                        <>
                            <tr>
                                <td colSpan={showGstData ? '3' : '6'}>
                                    Current Ending Cash<br />
                                    {
                                        showDetails &&
                                        <span className='g_muted g_small frm'>{total.currentEndingCashFormula}</span>
                                    }
                                </td>
                                <td className='g_text_right g_text_top'>
                                    {
                                        total.currentEndingCash < 0 ?
                                            `(${total.currentEndingCashF4})` : total.currentEndingCashF4
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={showGstData ? '3' : '6'}>
                                    Current Ending Cash Investment<br />
                                    {
                                        showDetails &&
                                        <span className='g_muted g_small frm'>{total.currentEndingCashInvestmentFormula}</span>
                                    }
                                </td>
                                <td className='g_text_right g_text_top'>
                                    {
                                        total.currentEndingCashInvestment < 0 ?
                                            `(${total.currentEndingCashInvestmentF4})` : total.currentEndingCashInvestmentF4
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={showGstData ? '3' : '6'}>
                                    <b>Current Cash as on {endMonthYear}</b><br />
                                    {
                                        showDetails &&
                                        <span className='g_muted g_small frm'>{total.currentCashFormula}</span>
                                    }
                                </td>
                                <td className='g_text_right g_text_top'><b>
                                    {
                                        total.currentCash < 0 ?
                                            `(${total.currentCashF4})` : total.currentCashF4
                                    }
                                </b></td>
                            </tr>
                        </>
                    }
                </>
                :
                // Positive Cash Margin: Show only Current Cash
                <>
                    {
                        total.currentYear !== "" ?
                            <tr>
                                <td colSpan={showGstData ? '3' : '6'}>
                                    <b>Current Cash as on {endMonthYear}</b><br />
                                    {
                                        showDetails &&
                                        <span className='g_muted g_small frm'>{total.currentCashFormula}</span>
                                    }
                                </td>
                                <td className='g_text_right g_text_top'><b>
                                    {
                                        total.currentCash < 0 ?
                                            `(${total.currentCashF4})` : total.currentCashF4
                                    }
                                </b></td>
                            </tr>
                            :
                            <tr>
                                <td colSpan={showGstData ? '3' : '6'}>
                                    <b>Current Cash as on {endMonthYear}</b><br />
                                    {
                                        showDetails &&
                                        <span className='g_muted g_small frm'>{total.provisionalCashFormula}</span>
                                    }
                                </td>
                                <td className='g_text_right g_text_top'><b>
                                    {
                                        total.provisionalCash < 0 ?
                                            `(${total.provisionalCashF4})` : total.provisionalCashF4
                                    }
                                </b></td>
                            </tr>
                    }
                </>
        }
    </>

const TotalRowUI = ({ total }) =>
    <tr>
        <td className='g_text_right'><b>Total</b></td>
        <td className='g_text_right'><b>{total.totalGstCollectionF4}</b></td>
        <td className='g_text_right'><b>{total.totalGstPaymentF4}</b></td>
        <td className='g_text_right'><b>
            {`${total.totalGstProfitLoss < 0 ? '(' : ''}${total.totalGstProfitLossF4}${total.totalGstProfitLoss < 0 ? ')' : ''}`}
        </b></td>
        <td className='g_text_right'><b>{total.totalBankCollectionF4}</b></td>
        <td className='g_text_right'><b>{total.totalBankPaymentF4}</b></td>
        <td className='g_text_right'><b>
            {`${total.totalBankProfitLoss < 0 ? '(' : ''}${total.totalBankProfitLossF4}${total.totalBankProfitLoss < 0 ? ')' : ''}`}
        </b></td>
    </tr>

const RowUI = ({ accountMonth, total }) =>
    <tr className={total && 'g_table_total'} style={accountMonth.ignored ? {opacity: 0.4} : {}}>
        <td className='g_text_right'>
            {accountMonth.yearMonth}
        </td>

        <td className='g_text_right'>
            {accountMonth.gstCollectionF4}
        </td>
        <td className='g_text_right'>
            {accountMonth.gstPaymentF4}
        </td>
        <td className='g_text_right'>
            {`${accountMonth.gstProfitLoss < 0 ? '(' : ''}${accountMonth.gstProfitLossF4}${accountMonth.gstProfitLoss < 0 ? ')' : ''}`}
        </td>

        <td className='g_text_right'>
            {accountMonth.bankCollectionF4}
        </td>
        <td className='g_text_right'>
            {accountMonth.bankPaymentF4}
        </td>
        <td className='g_text_right'>
            {`${accountMonth.bankProfitLoss < 0 ? '(' : ''}${accountMonth.bankProfitLossF4}${accountMonth.bankProfitLoss < 0 ? ')' : ''}`}
        </td>

    </tr>

export default Triangulation6MonthsUI
